import React, { Suspense } from "react";
import type { AddressSelectProps } from "./AddressSelectInner";

const LazyAddressSelect = React.lazy(() =>
  import("./AddressSelectInner").then((mod) => ({
    default: mod.AddressSelect,
  })),
);

export type { AddressOption, AddressSelectProps } from "./AddressSelectInner";

export function AddressSelect(props: AddressSelectProps) {
  return (
    <Suspense
      fallback={
        <div className="border rounded-md px-3 py-2 text-sm text-gray-500 bg-gray-50">
          Loading address selector...
        </div>
      }
    >
      <LazyAddressSelect {...props} />
    </Suspense>
  );
}
